/**
 * currency-display.js — toserof
 * lei ↔ Euro GÖRÜNÜM geçişi. Ödeme her zaman lei (RON) alınır (checkout tema dışı).
 * Kur: window.__eurCfg.rate (1 EUR = X lei). Euro = lei ÷ rate.
 * Fiyat metinlerini ("299,00 lei") DOM'da çevirir; seçim localStorage'da; dinamik içerik için observer;
 * EUR modunda şeffaflık notu enjekte eder. Sepet verisi/checkout DEĞİŞMEZ (sadece görüntü).
 */
(function () {
  "use strict";
  var cfg = window.__eurCfg || {};
  if (!cfg.enabled) return;
  var RATE = parseFloat(String(cfg.rate || "").replace(",", ".").trim());
  if (!RATE || RATE <= 0) return;

  var KEY = "yakups_currency";
  var notes = cfg.notes || {};
  var noteText = notes[cfg.locale] || notes.tr || notes.ro || notes.en || "";
  // "1.234,56 lei" veya "299,00 lei" — Avrupa formatı (binlik '.', ondalık ',')
  var FIND = /(\d{1,3}(?:[.  ]\d{3})*|\d+),(\d{2})\s*lei/gi;
  var QUICK = /\d,\d{2}\s*lei/i; // hızlı ön-eleme (global değil → güvenli .test)

  var origMap = new WeakMap();   // textNode -> orijinal lei metni
  var processed = [];            // dokunulan text node'lar (revert için)
  var mode = localStorage.getItem(KEY) === "EUR" ? "EUR" : "RON";

  function fmtEur(amount) {
    var s = amount.toFixed(2);
    var parts = s.split(".");
    var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "€" + intp + "," + parts[1];
  }
  function toEur(intStr, dec) {
    var ron = parseFloat(intStr.replace(/[.  ]/g, "") + "." + dec);
    return ron / RATE;
  }
  function convertText(t) {
    return t.replace(FIND, function (m, intp, dec) { return fmtEur(toEur(intp, dec)); });
  }

  function skip(node) {
    var p = node.parentNode;
    if (!p || p.nodeType !== 1) return true;
    var tag = p.nodeName;
    if (tag === "SCRIPT" || tag === "STYLE" || tag === "TEXTAREA" || tag === "OPTION") return true;
    if (p.closest && (p.closest(".wt-cur-switcher") || p.closest(".wt-eur-note"))) return true;
    return false;
  }

  function applyTo(root) {
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf("lei") === -1) return NodeFilter.FILTER_SKIP;
        if (skip(n)) return NodeFilter.FILTER_SKIP;
        return QUICK.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var batch = [], n;
    while ((n = w.nextNode())) batch.push(n);
    for (var i = 0; i < batch.length; i++) {
      var node = batch[i];
      if (!origMap.has(node)) { origMap.set(node, node.nodeValue); processed.push(node); }
      var conv = convertText(origMap.get(node));
      if (node.nodeValue !== conv) node.nodeValue = conv;
    }
  }

  function revertAll() {
    for (var i = 0; i < processed.length; i++) {
      var node = processed[i];
      if (origMap.has(node)) {
        var o = origMap.get(node);
        if (node.nodeValue !== o) node.nodeValue = o;
      }
    }
  }

  // ── şeffaflık notu (EUR modunda görünür; CSS body.wt-cur--eur) ──
  function ensureNotes() {
    if (!noteText) return;
    var anchors = [
      ".totals", ".cart__footer", '[class*="cart-drawer__footer"]', 'form[action="/cart"]',
      ".wt-product__price", ".price__container"
    ];
    for (var i = 0; i < anchors.length; i++) {
      document.querySelectorAll(anchors[i]).forEach(function (el) {
        if (el.dataset.eurNoteDone) return;
        el.dataset.eurNoteDone = "1";
        var note = document.createElement("div");
        note.className = "wt-eur-note";
        note.textContent = noteText;
        el.insertAdjacentElement("afterend", note);
      });
    }
  }

  function updateButtons() {
    document.querySelectorAll(".wt-cur-switcher__option").forEach(function (b) {
      var on = b.getAttribute("data-cur") === mode;
      b.classList.toggle("wt-cur-switcher__option--active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });
    // mobil trigger'daki aktif para birimi etiketi (🇹🇷 lei ▾)
    document.querySelectorAll("[data-cur-label]").forEach(function (el) {
      el.textContent = mode === "EUR" ? "€" : "lei";
    });
  }

  function setMode(m) {
    mode = m === "EUR" ? "EUR" : "RON";
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    document.body.classList.toggle("wt-cur--eur", mode === "EUR");
    updateButtons();
    ensureNotes();
    if (mode === "EUR") applyTo(document.body); else revertAll();
  }

  // tıklama (delegasyon)
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".wt-cur-switcher__option");
    if (!btn) return;
    e.preventDefault();
    setMode(btn.getAttribute("data-cur"));
  });

  // dinamik içerik (kart lazy-load, sepet/facet güncelleme, quick-add, AJAX) —
  // EUR modunda yeni düğümleri çevir. Mutasyonları BİRİKTİR (hiç atlama).
  var pending = null, queue = [];
  function flush() {
    pending = null;
    ensureNotes();
    var batch = queue; queue = [];
    for (var i = 0; i < batch.length; i++) {
      var n = batch[i];
      if (n.nodeType === 1) applyTo(n);
      else if (n.nodeType === 3 && QUICK.test(n.nodeValue || "") && !skip(n)) {
        if (!origMap.has(n)) { origMap.set(n, n.nodeValue); processed.push(n); }
        n.nodeValue = convertText(origMap.get(n));
      }
    }
  }
  var observer = new MutationObserver(function (muts) {
    if (mode !== "EUR") return;
    for (var i = 0; i < muts.length; i++)
      for (var j = 0; j < muts[i].addedNodes.length; j++) queue.push(muts[i].addedNodes[j]);
    if (!pending) pending = (window.requestAnimationFrame || function (f) { return setTimeout(f, 16); })(flush);
  });

  // Mevcut moda göre tüm durumu (body class, butonlar, not, fiyatlar) uygula
  function applyState() {
    document.body.classList.toggle("wt-cur--eur", mode === "EUR");
    updateButtons();
    ensureNotes();
    if (mode === "EUR") applyTo(document.body); else revertAll();
  }
  function init() {
    applyState();
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Her sayfa gösteriminde tekrar uygula — bfcache (geri/ileri), prefetch ve
  // AJAX navigasyonunda fiyatların lei'ye dönmesini önler.
  window.addEventListener("pageshow", function () {
    mode = localStorage.getItem(KEY) === "EUR" ? "EUR" : "RON";
    applyState();
  });
})();
